// React
import { PropsWithChildren, createContext } from "react"

// Types
import type { ProductType } from "types"

// Utils
import { useProduct } from "utils"


export const ProductContext = createContext<{
  data: ProductType[]
  isLoading: boolean,
  refetch?: () => void
}>({
  data: [],
  isLoading: false,
  refetch: () => {}
})

export function ProductProvider(params: PropsWithChildren<{}>): JSX.Element {
  // Hooks
  const { data, isLoading, refetch } = useProduct()

  console.log(data);
  

  return (
    <ProductContext.Provider value={{ data, isLoading, refetch }}>
      {params.children}
    </ProductContext.Provider>
  )
}